"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignToken = void 0;
const GlobalDesignToken_1 = require("./GlobalDesignToken");
class DesignToken extends GlobalDesignToken_1.GlobalDesignToken {
    constructor({ name, fallback = '', parent }) {
        super({ name, fallback });
        this.parents = Array.isArray(parent) ? parent : [parent];
    }
    getVar(overrideFallback) {
        if (!this.parents.length) {
            return `var(${this.name})`;
        }
        return `var(${this.name}, ${this.parents
            .slice(0, this.parents.length - 1)
            .reduceRight((acc, tokenable) => {
            return tokenable.getVar(acc);
        }, this.parents[this.parents.length - 1].getVar(overrideFallback))})`;
    }
    getStringValue(element) {
        return getComputedStyle(element || document.documentElement).getPropertyValue(this.name);
    }
    getIntValue(element) {
        return parseInt(getComputedStyle(element || document.documentElement).getPropertyValue(this.name), 10);
    }
}
exports.DesignToken = DesignToken;
exports.default = DesignToken;
//# sourceMappingURL=DesignToken.js.map